module.exports = __webpack_public_path__ + "static/media/wallet-onboarding-icon-one.e17e0b39.svg";